<template>
  <div class="login">
    <topnav title="登录"/>
    <div class="main">
      <div class="my-form">
        <div class="title">欢迎登录</div>
        <div class="input-group">
          <input type="text" placeholder="登录账号" v-model="formData.username">
        </div>
        <div class="input-group">
          <input type="password" placeholder="登录密码" v-model="formData.password">
        </div>
        <!-- <div class="input-group code">
          <input type="text" placeholder="验证码" v-model="formData.smsCode" maxlength="6">
          <van-image lazy-load width="1.8rem" height="0.7rem" src="https://img.yzcdn.cn/vant/cat.jpeg" />
        </div> -->
        <div class="input-group">
          <van-button type="primary" color="#3ad2d9" class="login" @click="goMy">立即登录</van-button>
        </div>
        <div class="input-group">
          <van-button type="primary" color="#ffffff" class="register" @click="goJump('Register')">免费注册</van-button>
          <van-button type="primary" color="#ffffff" class="password" @click="goJump('Forget')">找回密码</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Topnav from '@/components/Topnav'
import { login } from '@/api/user.js'
import { Notify, Toast } from 'vant';

export default {
  name: 'Login',
  components: {
    Topnav
  },
  data() {
    return {
      formData: {
        username: '',
        password: '',
      },
      formErrorTips: ['登录账号不能为空', '登录密码不能为空']
    }
  },
  mounted() {
  },
  methods: {
    goMy() {
      let arr = Object.keys(this.formData);
      for(let i=0; i<arr.length; i++) {
        if(this.formData[arr[i]] == '') {
          Toast({
            message: this.formErrorTips[i],
            position: 'bottom',
          });
          return false;
        }
      }
      login(this.formData).then(res => {
        Notify({ 
          type: 'success', 
          message: '登录成功',
          onClose: () => {
            window.localStorage.setItem('user', JSON.stringify(res.data));
            this.$router.push({
              name: 'My'
            })
          }
        });
      }).catch(err => {
        console.error(err);
      })
    },
    goJump(name) {
      this.$router.push({
        name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login{
  .main{
    padding-top: var(--window-top);
    .my-form{
      margin-top: 2rem;
      padding: 0 0.4rem;
      .title{
        font-size: 0.48rem;
        color: #666666;
        margin-bottom: 0.6rem;
      }
      .input-group{
        width: 5.2rem;
        margin-bottom: 0.4rem;
        margin-left: 0.6rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &.code input{
            width: 3rem;
        }
        input{
          width: 100%;
          height: 0.8rem;
          line-height: 0.8rem;
          font-size: 0.32rem;
          border: 1px solid #dcdcdc;
          padding: 4px 8px;
          &::placeholder{
            color: #a4a4a4;
          }
        }
        button{
          width: 2rem;
          height: 0.8rem;
          line-height: 0.8rem;
          &.login{
            width: 100%;
            color: #ffffff;
          }
          &.register{
            color: #2eaeb4!important;
            border-color: #dfdfdf!important;
          }
          &.password{
            color: #2eaeb4!important;
            border-color: #dfdfdf!important;
          }
        }
      }
    }
  }
}
</style>